"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _auth = require("@/utils/auth");
var _dishGroup = require("@/api/goods/dishGroup");
var _goods = require("@/api/goods/goods");
var _primaryMenu = require("@/api/goods/primaryMenu");
var _asyncTask = require("@/api/job/asyncTask");
var _sortablejs = require("sortablejs");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default2 = exports.default = {
  name: 'dishGroupManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  props: {
    listQuery: {
      type: Object,
      default: function _default() {
        return {
          page: 1,
          limit: 10,
          keywords: null,
          subtitle: null,
          regionCategory: null
        };
      }
    },
    keywords: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      resPath: '',
      editVisible: false,
      editForm: {
        id: null,
        name: '',
        nameEn: '',
        subtitle: '',
        regionCategory: '',
        iconUrl: '',
        beginTimeStr: null,
        endTimeStr: null,
        subscript: '',
        type: 1,
        checkedWeekdays: [],
        checkedScene: [],
        primaryMenuId: null,
        hideFlag: 0,
        copyFromGroupId: null,
        copyItems: false
      },
      editRules: {
        name: [{
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }]
      },
      timeRange: [new Date(0, 0, 0, 0, 0), new Date(0, 0, 23, 59, 59)],
      uploadFileList: [],
      previewDialog: {
        visible: false,
        url: ''
      },
      weekdays: [{
        label: '周一',
        value: 1
      }, {
        label: '周二',
        value: 2
      }, {
        label: '周三',
        value: 3
      }, {
        label: '周四',
        value: 4
      }, {
        label: '周五',
        value: 5
      }, {
        label: '周六',
        value: 6
      }, {
        label: '周日',
        value: 7
      }],
      scenes: [{
        label: '堂食',
        value: '1'
      }, {
        label: '自提',
        value: '2'
      }, {
        label: '外卖',
        value: '3'
      }],
      primaryMenuList: [],
      itemVisible: false,
      itemFilter: {
        groupId: null,
        page: 1,
        limit: 10,
        keywords: null
      },
      itemList: [],
      itemTotal: 0,
      itemAddVisible: false,
      itemAddQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        dataId: null,
        dataType: 'menuDishGroup',
        categories: []
      },
      itemAddTotal: 0,
      itemAddData: [],
      importDialogVisible: false,
      importing: false,
      importForm: {
        operation: 'import'
      },
      // 异步任务相关
      importTaskVisible: false,
      importTaskId: null,
      importTaskStatus: '',
      // pending, running, completed, failed
      importTaskProgress: 0,
      importTaskCurrent: 0,
      importTaskTotal: 0,
      importTaskError: '',
      importTaskTimer: null,
      selectedGroups: [],
      batchClearDialogVisible: false,
      secondConfirmDialogVisible: false,
      batchClearing: false,
      migrateDialogVisible: false,
      migrating: false,
      migrateForm: {
        targetGroupId: null
      },
      groupOptions: [],
      currentGroupName: '',
      selectedItems: [],
      categories: [],
      selectedAddItems: []
    };
  },
  created: function created() {
    this.getList();
    this.getPrimaryMenuPage();
    this.getCategories();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPollingTaskProgress();
  },
  watch: {
    keywords: {
      handler: function handler(val) {
        this.listQuery.keywords = val || null;
      },
      immediate: true
    }
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    },
    uploadHeaders: function uploadHeaders() {
      return {
        "X-Token": (0, _auth.getToken)()
      };
    },
    uploadUrl: function uploadUrl() {
      return process.env.VUE_APP_PIM_API + 'xyMenuDishGroup/importGoodsExcel';
    },
    uploadData: function uploadData() {
      return {
        operation: this.importForm.operation
      };
    },
    selectedItemCount: function selectedItemCount() {
      return this.selectedItems.length;
    },
    // 结束时间选择器的配置（起始时间之后的时间可选）
    editFormEndTimeOptions: function editFormEndTimeOptions() {
      var beginTime = this.editForm.beginTimeStr;
      if (!beginTime) {
        return {
          selectableRange: '00:00:00 - 23:59:00'
        };
      }
      // 将 HH:mm 格式转换为 HH:mm:ss
      var beginTimeWithSeconds = beginTime + ':00';
      return {
        selectableRange: "".concat(beginTimeWithSeconds, " - 23:59:00")
      };
    }
  },
  methods: {
    handleItemAddFilter: function handleItemAddFilter() {
      var _this = this;
      this.itemAddVisible = true;
      this.listLoading = true;
      // 重置分类筛选
      this.itemAddQuery.categories = [];
      this.itemAddQuery.categoryFirstId = null;
      this.itemAddQuery.categorySecondId = null;
      this.selectedAddItems = [];
      // 删除categories字段，只发送后台认识的字段
      var queryParams = _objectSpread({}, this.itemAddQuery);
      delete queryParams.categories;
      (0, _goods.queryList)(queryParams).then(function (response) {
        if (response) {
          _this.itemAddData = response.records;
          _this.itemAddTotal = response.total;
        }
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    // 搜索添加商品列表
    searchAddGoods: function searchAddGoods() {
      var _this2 = this;
      // 将分类数组转换为 categoryFirstId 和 categorySecondId
      if (this.itemAddQuery.categories && this.itemAddQuery.categories.length > 0) {
        this.itemAddQuery.categoryFirstId = this.itemAddQuery.categories[0];
        this.itemAddQuery.categorySecondId = this.itemAddQuery.categories[1] || null;
      } else {
        this.itemAddQuery.categoryFirstId = null;
        this.itemAddQuery.categorySecondId = null;
      }
      this.itemAddQuery.page = 1;
      this.listLoading = true;
      // 删除categories字段，只发送后台认识的字段
      var queryParams = _objectSpread({}, this.itemAddQuery);
      delete queryParams.categories;
      (0, _goods.queryList)(queryParams).then(function (response) {
        if (response) {
          _this2.itemAddData = response.records;
          _this2.itemAddTotal = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleItemSelectionChange: function handleItemSelectionChange(selection) {
      this.selectedItems = selection;
    },
    addGoods: function addGoods(goodsId) {
      var _this3 = this;
      this.$confirm('确认添加此商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _dishGroup.addDishGroupItem)({
          goodsId: goodsId,
          groupId: _this3.itemFilter.groupId
        }).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this3.$message.success('添加成功');
            _this3.getItemAddData(); // 刷新当前页
          } else {
            _this3.$message.error(res.msg || '添加失败');
          }
        });
      }).catch(function () {});
    },
    deleteItem: function deleteItem(id) {
      var _this4 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _dishGroup.deleteDishGroupItem)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this4.$message.success('删除成功');
            _this4.getItems();
          } else {
            _this4.$message.error(res.msg || '删除失败');
          }
        });
      }).catch(function () {});
    },
    handleItemDeleteFilter: function handleItemDeleteFilter() {
      var _this5 = this;
      if (this.selectedItems.length === 0) {
        this.$message.warning('请至少选择一个商品');
        return;
      }
      this.$confirm('确认批量删除选中的商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var ids = _this5.selectedItems.map(function (row) {
          return row.id;
        });
        (0, _dishGroup.batchDeleteDishGroupItem)({
          ids: ids
        }).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this5.$message.success('批量删除成功');
            _this5.getItems();
            _this5.selectedItems = [];
          } else {
            _this5.$message.error(res.msg || '批量删除失败');
          }
        });
      }).catch(function () {});
    },
    handleItemDialog: function handleItemDialog(id) {
      this.itemFilter.groupId = id;
      this.itemFilter.page = 1;
      this.itemFilter.keywords = null; // 清空搜索
      this.itemAddQuery.dataId = id;
      this.selectedItems = []; // 清空选中项
      this.getItems();
      this.itemVisible = true;
    },
    getItems: function getItems() {
      var _this6 = this;
      this.listLoading = true;
      (0, _dishGroup.getDishGroupItems)(this.itemFilter).then(function (response) {
        if (response) {
          _this6.itemList = response.records;
          _this6.itemTotal = response.total;
        }
        setTimeout(function () {
          _this6.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this6.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    getPrimaryMenuPage: function getPrimaryMenuPage() {
      var _this7 = this;
      (0, _primaryMenu.queryList)({
        limit: 1000
      }).then(function (res) {
        _this7.primaryMenuList = res.records;
      });
    },
    // 获取分类树
    getCategories: function getCategories() {
      var _this8 = this;
      (0, _goods.getCategoryTree)().then(function (res) {
        _this8.categories = res.data;
      });
    },
    // 添加商品表格选择变化
    handleItemAddSelectionChange: function handleItemAddSelectionChange(selection) {
      this.selectedAddItems = selection;
    },
    // 判断商品是否可勾选
    checkSelectable: function checkSelectable(row) {
      // 已存在的商品不能勾选
      return !row.checked;
    },
    // 批量添加商品
    handleBatchAddGoods: function handleBatchAddGoods() {
      var _this9 = this;
      if (this.selectedAddItems.length === 0) {
        this.$message.warning('请至少选择一个商品');
        return;
      }
      this.$confirm("\u786E\u8BA4\u6279\u91CF\u6DFB\u52A0\u9009\u4E2D\u7684 ".concat(this.selectedAddItems.length, " \u4E2A\u5546\u54C1\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 批量添加商品
        var promises = _this9.selectedAddItems.map(function (row) {
          return (0, _dishGroup.addDishGroupItem)({
            goodsId: row.id,
            groupId: _this9.itemFilter.groupId
          });
        });
        Promise.all(promises).then(function (results) {
          var successCount = results.filter(function (res) {
            return res.code === 0 || res.code === 200;
          }).length;
          if (successCount === _this9.selectedAddItems.length) {
            _this9.$message.success('批量添加成功');
          } else if (successCount > 0) {
            _this9.$message.warning("\u6279\u91CF\u6DFB\u52A0\u90E8\u5206\u6210\u529F\uFF0C\u6210\u529F ".concat(successCount, " \u4E2A\uFF0C\u5931\u8D25 ").concat(_this9.selectedAddItems.length - successCount, " \u4E2A"));
          } else {
            _this9.$message.error('批量添加失败');
          }
          _this9.getItemAddData(); // 刷新当前页
        }).catch(function () {
          _this9.$message.error('批量添加失败');
        });
      }).catch(function () {});
    },
    //  上传图片(icon)
    handlePictureUpload: function handlePictureUpload(_ref) {
      var _this0 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _goods.uploadPhotoAddOrUpd)(formData).then(function (res) {
        var url = res.data;
        // 更新展示地址
        _this0.editForm.iconUrl = url;
        // 替换上传组件的 fileList（最多一张）
        _this0.uploadFileList = [{
          name: '展示图',
          url: url
        }];
        _this0.$message.success('上传成功');
      }).catch(function () {
        _this0.$message.error('上传失败');
      });
    },
    handleEdit: function handleEdit(id) {
      var _this1 = this;
      (0, _dishGroup.getById)(id).then(function (res) {
        _this1.editForm = res.data;
        // 回显已上传的icon图片
        if (_this1.editForm.iconUrl) {
          _this1.uploadFileList = [{
            name: '展示图',
            url: _this1.editForm.iconUrl
          }];
        } else {
          _this1.uploadFileList = [];
        }
        _this1.editVisible = true;
      });
    },
    handleCopy: function handleCopy(id) {
      var _this10 = this;
      (0, _dishGroup.getById)(id).then(function (res) {
        var sourceData = res.data;
        _this10.editForm = {
          id: null,
          name: '',
          nameEn: sourceData.nameEn || '',
          subtitle: sourceData.subtitle || '',
          regionCategory: sourceData.regionCategory || '',
          iconUrl: sourceData.iconUrl || '',
          beginTimeStr: sourceData.beginTimeStr,
          endTimeStr: sourceData.endTimeStr,
          subscript: sourceData.subscript || '',
          type: sourceData.type || 1,
          checkedWeekdays: sourceData.checkedWeekdays || [],
          checkedScene: sourceData.checkedScene || [],
          primaryMenuId: sourceData.primaryMenuId,
          hideFlag: sourceData.hideFlag || 0,
          copyFromGroupId: id,
          copyItems: true
        };
        // 回显已上传的icon图片
        if (_this10.editForm.iconUrl) {
          _this10.uploadFileList = [{
            name: '展示图',
            url: _this10.editForm.iconUrl
          }];
        } else {
          _this10.uploadFileList = [];
        }
        _this10.editVisible = true;
      });
    },
    handleDelete: function handleDelete(id) {
      var _this11 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _dishGroup.deleteById)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this11.$message.success('删除成功');
            _this11.getList();
          } else {
            _this11.$message.error(res.msg || '删除失败');
          }
        });
      }).catch(function () {});
    },
    handleCreate: function handleCreate() {
      this.editForm = {
        id: null,
        name: '',
        nameEn: '',
        subtitle: '',
        regionCategory: '',
        iconUrl: '',
        beginTimeStr: null,
        endTimeStr: null,
        primaryMenuId: null,
        subscript: '',
        checkedWeekdays: [],
        checkedScene: [],
        hideFlag: 0,
        type: 1,
        copyFromGroupId: null,
        copyItems: false
      };
      this.uploadFileList = [];
      this.editVisible = true;
    },
    saveEntity: function saveEntity() {
      var _this12 = this;
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _dishGroup.save)(_this12.editForm).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this12.$message.success('操作成功');
            _this12.getList();
            _this12.editVisible = false;
          } else {
            _this12.$message.error(res.message || '操作失败');
          }
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this13 = this;
      this.listLoading = true;
      (0, _dishGroup.queryList)(this.listQuery).then(function (response) {
        if (response) {
          _this13.dataList = response.records;
          _this13.total = response.total;
        }
        setTimeout(function () {
          _this13.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this13.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      //重置搜索
      this.listQuery.keywords = null;
      this.listQuery.subtitle = null;
      this.listQuery.regionCategory = null;
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
      // 通知父组件分页变化
      this.$emit('page-change', this.listQuery);
    },
    getItemPage: function getItemPage() {
      //分组商品弹窗分页
      this.getItems();
    },
    getItemAddPage: function getItemAddPage() {
      //添加商品弹窗分页
      this.getItemAddData();
    },
    getItemAddData: function getItemAddData() {
      var _this14 = this;
      // 将分类数组转换为 categoryFirstId 和 categorySecondId
      if (this.itemAddQuery.categories && this.itemAddQuery.categories.length > 0) {
        this.itemAddQuery.categoryFirstId = this.itemAddQuery.categories[0];
        this.itemAddQuery.categorySecondId = this.itemAddQuery.categories[1] || null;
      } else {
        this.itemAddQuery.categoryFirstId = null;
        this.itemAddQuery.categorySecondId = null;
      }
      // 不重置页码 - 保持当前页
      this.listLoading = true;
      // 删除categories字段，只发送后台认识的字段
      var queryParams = _objectSpread({}, this.itemAddQuery);
      delete queryParams.categories;
      (0, _goods.queryList)(queryParams).then(function (response) {
        if (response) {
          _this14.itemAddData = response.records;
          _this14.itemAddTotal = response.total;
        }
        setTimeout(function () {
          _this14.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this14.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleRemoveFile: function handleRemoveFile() {
      this.uploadFileList = [];
      this.editForm.iconUrl = '';
    },
    handlePreview: function handlePreview(file) {
      this.previewDialog.url = file.url;
      this.previewDialog.visible = true;
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.editForm.checkedWeekdays = val ? [1, 2, 3, 4, 5, 6, 7] : [];
    },
    // 开始时间变更时，如果结束时间小于等于开始时间，则清空结束时间
    handleBeginTimeChange: function handleBeginTimeChange() {
      if (this.editForm.beginTimeStr && this.editForm.endTimeStr) {
        if (this.editForm.endTimeStr <= this.editForm.beginTimeStr) {
          this.editForm.endTimeStr = null;
          this.$message.warning('结束时间必须大于开始时间');
        }
      }
    },
    // 打开导入弹框
    handleOpenImportDialog: function handleOpenImportDialog() {
      this.importDialogVisible = true;
      this.importForm.operation = 'import';
    },
    // 下载导入模板
    handleDownloadTemplate: function handleDownloadTemplate() {
      var _this15 = this;
      if (!this.importForm.operation) {
        this.$message.warning('请先选择操作类型');
        return;
      }
      var operation = this.importForm.operation === 'import' ? '导入' : '删除';
      (0, _dishGroup.downloadGoodsImportTemplate)(this.importForm.operation).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "\u5206\u7EC4\u5546\u54C1".concat(operation, "\u6A21\u677F.xlsx");
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this15.$message.error('下载失败');
      });
    },
    // 确认导入
    handleConfirmImport: function handleConfirmImport() {
      if (!this.importForm.operation) {
        this.$message.warning('请选择操作类型');
        return;
      }
      var files = this.$refs.uploadRef.uploadFiles;
      if (!files || files.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.importing = true;
      this.$refs.uploadRef.submit();
    },
    // 上传成功回调
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      this.importing = false;
      if (response.code === 200 || response.code === 0) {
        var data = response.data;

        // 处理异步任务响应
        if (data && data.status) {
          if (data.status === 'exists_running') {
            // 已有执行中的任务
            this.$message.warning(data.message || '有任务正在执行中');
            var runningTask = data.runningTask;
            if (runningTask) {
              this.importTaskId = runningTask.taskId;
              this.importTaskStatus = runningTask.status || 'running';
              this.importTaskProgress = runningTask.progress || 0;
              this.importTaskCurrent = runningTask.current || 0;
              this.importTaskTotal = runningTask.total || 0;
              this.importTaskVisible = true;

              // 开始轮询任务进度
              this.startPollingTaskProgress();
            }
          } else if (data.status === 'created') {
            // 任务创建成功
            this.importTaskId = data.taskId;
            this.importTaskStatus = 'pending';
            this.importTaskProgress = 0;
            this.importTaskCurrent = 0;
            this.importTaskTotal = 0;
            this.importTaskVisible = true;
            this.$message.success(data.message || '导入任务已创建，正在后台执行');

            // 开始轮询任务进度
            this.startPollingTaskProgress();
          } else {
            this.$message.error('未知的状态：' + data.status);
          }
        } else {
          // 兼容旧版本同步处理
          var successCount = data.successCount || 0;
          var errorMessages = data.errorMessages || [];
          var totalProcessed = data.totalProcessed || 0;
          if (errorMessages.length > 0) {
            this.$message.warning("\u5BFC\u5165\u5B8C\u6210\uFF0C\u6210\u529F".concat(successCount, "\u6761\uFF0C\u5931\u8D25").concat(errorMessages.length, "\u6761\uFF1A").concat(errorMessages.join(', ')));
          } else {
            this.$message.success("\u5BFC\u5165\u6210\u529F\uFF0C\u5171\u5904\u7406".concat(totalProcessed, "\u6761\u6570\u636E"));
          }

          // 刷新分组列表
          this.getList();

          // 成功后关闭弹窗
          this.importDialogVisible = false;
        }
      } else {
        this.$message.error(response.msg || '导入失败');
      }
    },
    // 导入弹框关闭时的处理
    handleImportDialogClose: function handleImportDialogClose() {
      // 清除上传文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
      // 重置操作类型
      this.importForm.operation = 'import';

      // 清除任务轮询定时器
      if (this.importTaskTimer) {
        clearInterval(this.importTaskTimer);
        this.importTaskTimer = null;
      }

      // 重置任务状态
      this.importTaskVisible = false;
      this.importTaskId = null;
      this.importTaskStatus = '';
      this.importTaskProgress = 0;
      this.importTaskCurrent = 0;
      this.importTaskTotal = 0;
      this.importTaskError = '';
      this.importing = false;
    },
    // 开始轮询任务进度
    startPollingTaskProgress: function startPollingTaskProgress() {
      var _this16 = this;
      if (this.importTaskTimer) {
        clearInterval(this.importTaskTimer);
      }

      // 立即查询一次
      this.pollTaskProgress();

      // 每2秒查询一次
      this.importTaskTimer = setInterval(function () {
        _this16.pollTaskProgress();
      }, 2000);
    },
    // 轮询任务进度
    pollTaskProgress: function pollTaskProgress() {
      var _this17 = this;
      if (!this.importTaskId) {
        return;
      }

      // 调用任务进度查询接口
      (0, _asyncTask.getTaskProgress)(this.importTaskId).then(function (response) {
        if (response && (response.code === 200 || response.code === 0)) {
          var progress = response.data;
          if (!progress) return;
          _this17.importTaskStatus = progress.status;
          _this17.importTaskProgress = progress.progress || 0;
          _this17.importTaskCurrent = progress.current || 0;
          _this17.importTaskTotal = progress.total || 0;

          // 如果任务完成或失败，停止轮询
          if (progress.status === 'completed') {
            _this17.stopPollingTaskProgress();
            _this17.$message.success("\u5BFC\u5165\u5B8C\u6210\uFF01\u5171\u5904\u7406 ".concat(_this17.importTaskTotal, " \u6761\u6570\u636E"));
            _this17.getList(); // 刷新列表

            // 3秒后关闭弹窗
            setTimeout(function () {
              _this17.importDialogVisible = false;
            }, 3000);
          } else if (progress.status === 'failed') {
            _this17.stopPollingTaskProgress();
            _this17.importTaskError = progress.errorMessage || '导入失败';
            // 不显示错误提示框，只在任务进度区域显示失败状态
          } else if (progress.status === 'cancelled') {
            _this17.stopPollingTaskProgress();
            _this17.importTaskError = '任务已被取消';
          }
        }
      }).catch(function (error) {
        console.error('查询任务进度失败:', error);
      });
    },
    // 停止轮询任务进度
    stopPollingTaskProgress: function stopPollingTaskProgress() {
      if (this.importTaskTimer) {
        clearInterval(this.importTaskTimer);
        this.importTaskTimer = null;
      }
    },
    // 上传失败回调
    handleUploadError: function handleUploadError(err, file, fileList) {
      this.importing = false;
      console.error('菜品分组上传失败：', err);
      // 不显示错误提示框，错误会在任务进度区域显示
    },
    // 下载分组信息
    handleDownloadGroupInfo: function handleDownloadGroupInfo() {
      var _this18 = this;
      this.$confirm('确认下载现有分组信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(function () {
        (0, _dishGroup.downloadGroupInfo)().then(function (response) {
          var blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "\u5206\u7EC4\u4FE1\u606F_".concat(new Date().getTime(), ".xlsx");
          link.click();
          window.URL.revokeObjectURL(link.href);
          _this18.$message.success('下载成功');
        }).catch(function (error) {
          console.error('下载失败:', error);
          _this18.$message.error('下载失败');
        });
      }).catch(function () {});
    },
    // 表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedGroups = selection;
    },
    // 打开批量清空弹窗
    handleBatchClear: function handleBatchClear() {
      if (this.selectedGroups.length === 0) {
        this.$message.warning('请至少选择一个分组');
        return;
      }
      this.batchClearDialogVisible = true;
    },
    // 第一次确认
    handleFirstConfirm: function handleFirstConfirm() {
      this.batchClearDialogVisible = false;
      this.secondConfirmDialogVisible = true;
    },
    // 第二次确认并执行清空
    handleSecondConfirm: function handleSecondConfirm() {
      var _this19 = this;
      var groupIds = this.selectedGroups.map(function (group) {
        return group.id;
      });
      this.batchClearing = true;
      (0, _dishGroup.batchClearGroupItems)({
        ids: groupIds
      }).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this19.$message.success('批量清空成功');
          _this19.getList();
          // 清空选择
          _this19.$refs.groupTable.clearSelection();
          _this19.selectedGroups = [];
        }
        _this19.secondConfirmDialogVisible = false;
      }).catch(function (error) {
        console.error('批量清空失败:', error);
        _this19.$message.error('批量清空失败');
      }).finally(function () {
        _this19.batchClearing = false;
      });
    },
    // 关闭批量清空弹窗
    handleBatchClearDialogClose: function handleBatchClearDialogClose() {
      this.batchClearDialogVisible = false;
    },
    // 打开迁移弹窗
    handleMigrateItems: function handleMigrateItems() {
      var _this20 = this;
      if (this.selectedItems.length === 0) {
        this.$message.warning('请至少选择一个商品');
        return;
      }
      // 获取当前分组名称
      var currentGroup = this.dataList.find(function (group) {
        return group.id === _this20.itemFilter.groupId;
      });
      this.currentGroupName = currentGroup ? currentGroup.name : '';
      // 获取所有分组列表（排除当前分组）
      this.getGroupOptions();
      this.migrateDialogVisible = true;
    },
    // 获取分组选项
    getGroupOptions: function getGroupOptions() {
      var _this21 = this;
      (0, _dishGroup.queryList)({
        limit: 1000,
        page: 1
      }).then(function (response) {
        if (response) {
          _this21.groupOptions = response.records;
        }
      });
    },
    // 关闭迁移弹窗
    handleMigrateDialogClose: function handleMigrateDialogClose() {
      this.migrateForm.targetGroupId = null;
      this.$refs.migrateFormRef && this.$refs.migrateFormRef.clearValidate();
    },
    // 确认迁移
    handleConfirmMigrate: function handleConfirmMigrate() {
      var _this22 = this;
      this.$refs.migrateFormRef.validate(function (valid) {
        if (valid) {
          if (_this22.selectedItems.length === 0) {
            _this22.$message.warning('请至少选择一个商品');
            return;
          }
          if (!_this22.migrateForm.targetGroupId) {
            _this22.$message.warning('请选择目标分组');
            return;
          }
          var itemIds = _this22.selectedItems.map(function (row) {
            return row.id;
          });
          _this22.migrating = true;

          // 调用迁移API
          (0, _dishGroup.migrateDishGroupItems)({
            sourceGroupId: _this22.itemFilter.groupId,
            targetGroupId: _this22.migrateForm.targetGroupId,
            itemIds: itemIds
          }).then(function (res) {
            if (res.code === 0 || res.code === 200) {
              _this22.$message.success('迁移成功');
              _this22.migrateDialogVisible = false;
              _this22.getItems();
              _this22.getList(); // 刷新主列表以更新商品数量
              _this22.selectedItems = [];
            }
          }).catch(function (error) {
            console.error('迁移失败:', error);
            _this22.$message.error('迁移失败');
          }).finally(function () {
            _this22.migrating = false;
          });
        }
      });
    }
  }
};